import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { failed: boolean };

export class RenderErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Study Space interface rendering failed", error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="render-error" role="alert">
      <section>
        <p>Study Space was updated</p>
        <h1>Please reload this page.</h1>
        <p>Your saved account and chat history are safe. Reload to use the newest version of the website.</p>
        <button className="button primary" onClick={() => window.location.reload()}>Reload page</button>
      </section>
    </main>;
  }
}
